import { useSelector } from "react-redux";
import DateFilter from "../../../components/common/DateFilter";

function HeaderTableRecon({
  setParentStartDate,
  setParentEndDate,
  currentPage,
  getReconciliationData,
}) {
  const token = useSelector((state) => state.userReducer.token);

  const handleDateChange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    setParentStartDate(startDate);
    setParentEndDate(endDate);

    getReconciliationData(token, currentPage, startDate, endDate);
  };

  return (
    <>
      <div className="recon-header">
        <h2 className="area-top-management">Chargeback Table</h2>
      </div>
      <DateFilter onDateChange={handleDateChange} />
    </>
  );
}

export default HeaderTableRecon;
